import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';

export function SEO({ description, lang, meta, title, imageUrl }) {
	const { site, logo } = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
					description
					author
				}
			}
			logo: file(relativePath: { eq: "bf-logo.svg" }) {
				publicURL
			}
		}
	`);

	const metaDescription = description || site.siteMetadata.description;
	const defaultTitle = site.siteMetadata?.title;
	let image = imageUrl;
	if (!image) {
		image = logo.publicURL;
	}
	return (
		<Helmet
			htmlAttributes={{
				lang
			}}
			title={title}
			titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : ''}
			meta={[
				{
					name: `description`,
					content: metaDescription
				},
				{
					property: `og:title`,
					content: title
				},
				{
					property: `og:description`,
					content: metaDescription
				},
				{
					property: `og:type`,
					content: `website`
				},
				{
					property: `og:image`,
					content: image
				},
				{
					name: `twitter:card`,
					content: `summary_large_image`
				},
				{
					name: `twitter:creator`,
					content: site.siteMetadata?.author || ``
				},
				{
					name: `twitter:title`,
					content: title
				},
				{
					name: `twitter:description`,
					content: metaDescription
				},
				{
					name: 'google-site-verification',
					content: 'mAOoiILsuxCwFerPZTcIdUr_5ha8h2b9BRGAPVcw4s0'
				}
			].concat(meta)}
		>
			<script>
				{`
					(function(g,d,o){
					g._ltq=g._ltq||[];g._lt=g._lt||function(){g._ltq.push(arguments)};
					var h=location.protocol==='https:'?'https://d.line-scdn.net':'http://d.line-cdn.net';
					var s=d.createElement('script');s.async=1;
					s.src=o||h+'/n/line_tag/public/release/v1/lt.js';
					var t=d.getElementsByTagName('script')[0];t.parentNode.insertBefore(s,t);
						})(window, document);
					_lt('init', {
					customerType: 'account',
					tagId: 'dd45d771-2063-4643-85be-280a5bf2274d'
					});
					_lt('send', 'pv', ['dd45d771-2063-4643-85be-280a5bf2274d']);
					`}
			</script>
			<noscript>
				{`
				<img height="1" width="1" style="display:none"
					src="https://tr.line.me/tag.gif?c_t=lap&t_id=dd45d771-2063-4643-85be-280a5bf2274d&e=pv&noscript=1" />
				`}
			</noscript>
		</Helmet>
	);
}

SEO.defaultProps = {
	lang: `ja`,
	meta: [],
	description: ``,
	imageUrl: ``
};

SEO.propTypes = {
	description: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.arrayOf(PropTypes.object),
	title: PropTypes.string.isRequired,
	imageUrl: PropTypes.string
};
